// extracted by mini-css-extract-plugin
export default {"cls1":"VeloProgressIndicator-ProgressContainer_cls1__Hqpzu","cls2":"VeloProgressIndicator-ProgressContainer_cls2__wbQ2p VeloProgressIndicator-ProgressContainer_cls1__Hqpzu"};